export interface ChangelogEntry {
  version: string;
  date: string;
  label?: string;
  changes: { type: 'new' | 'fix' | 'improve' | 'security'; text: string }[];
}

export const APP_VERSION = '1.5.1';

export const CHANGELOG: ChangelogEntry[] = [
  {
    version: '1.5.1',
    date: '08.10.2026.',
    label: 'Prijava i pretraga liftova',
    changes: [
      { type: 'fix', text: 'Obavezna promena početne lozinke prikazuje se nakon prijave' },
      { type: 'improve', text: 'Početni prikaz sadrži liftove sa aktivnim radnim nalozima' },
      { type: 'improve', text: 'Pretragom se mogu pronaći i aktivni liftovi bez radnog naloga' },
    ],
  },
  {
    version: '1.5.0',
    date: '14.05.2026.',
    label: 'Multi-nalog & Kompresija slika',
    changes: [
      { type: 'new', text: 'Kreiranje naloga za više klijenata i liftova odjednom (desktop i mobile)' },
      { type: 'new', text: 'URL filter parametri na stranici naloga (employee, status, tip)' },
      { type: 'new', text: 'Klikabilne statistike radnika → direktan prelaz na filtrirane naloge' },
      { type: 'new', text: 'Klikabilne statistike liftova po tipu → direktan prelaz na filtrirane naloge' },
      { type: 'fix', text: 'Kompresija slika primenjena i za pauze i zatvaranje naloga (ranije samo za admin upload)' },
      { type: 'fix', text: 'Cron job za kompresiju sada skenira sve fajlove na disku (54 slike, -141MB)' },
      { type: 'fix', text: 'Ispravan prikaz van_rada statusa na detalju lifta' },
      { type: 'fix', text: 'Ispravljen Internal Server Error pri izmeni lifta' },
    ],
  },
  {
    version: '1.4.0',
    date: '04.2026.',
    label: 'Push notifikacije & JWT sigurnost',
    changes: [
      { type: 'new', text: 'FCM native push notifikacije za Android uređaje' },
      { type: 'new', text: 'Web push notifikacije u browseru' },
      { type: 'security', text: 'JWT autentifikacija za sve API endpoint-ove' },
      { type: 'new', text: 'Notifikacije tab u Master Control Panel-u' },
      { type: 'new', text: 'Notifikacije za pauze, nastavak rada, upload fajlova i napomene' },
      { type: 'improve', text: 'Unified 15s polling za notifikacije' },
    ],
  },
  {
    version: '1.3.0',
    date: '03.2026.',
    label: 'Mapa & Redesign',
    changes: [
      { type: 'new', text: 'Real-time mapa klijenata sa pinovima po tipu lifta i statusu' },
      { type: 'new', text: 'Geocoding i prikaz liftova u popup-u na mapi' },
      { type: 'new', text: 'Status lifta po tipu zadatka na pinovima mape' },
      { type: 'improve', text: 'Redesign: LiftDetailsPage, ClientsPage, ClientDetailsPage, Galerija' },
      { type: 'improve', text: 'Dashboard servisi graf, badge Intervencija' },
      { type: 'improve', text: 'Master Control Panel - fullwidth layout' },
    ],
  },
  {
    version: '1.2.0',
    date: '03.2026.',
    label: 'Dežurstvo & Mobile Admin',
    changes: [
      { type: 'new', text: 'Inline kreiranje naloga tokom dežurstva (mobile worker)' },
      { type: 'new', text: 'Duty toggle 2/3 + 1/3 layout za dežurstvo' },
      { type: 'new', text: 'Mobile Admin View: puni pregled radnika, klijenata, kalendara' },
      { type: 'new', text: 'Unified renderHeader za sve mobile view-ove' },
      { type: 'new', text: 'Admin profil stranica sa promenom lozinke' },
      { type: 'improve', text: 'BarChart3 stats panel za radnike' },
      { type: 'fix', text: 'UTC timestamp prikaz za dežurstvo' },
    ],
  },
  {
    version: '1.1.0',
    date: '02.2026.',
    label: 'Master rola & Android',
    changes: [
      { type: 'new', text: 'Master rola sa punim permisijama i Master Control Panel-om' },
      { type: 'new', text: 'Priprema za Google Play (package ID, ikone, keystore)' },
      { type: 'new', text: 'Capacitor Android podrška i mobile worker view' },
      { type: 'new', text: 'Blue tema i novi UI dizajn kartica i headera' },
      { type: 'improve', text: 'Reorganizacija baze: lift polja u elevators tabeli' },
      { type: 'fix', text: 'Bezbedan JSON parsing pri promeni lozinke' },
    ],
  },
  {
    version: '1.0.1',
    date: '01.2026.',
    label: 'EVO CRM - rani release',
    changes: [
      { type: 'new', text: 'Import klijenata i liftova iz CSV/Excel fajlova' },
      { type: 'new', text: 'Kalendar i Timeline pregled naloga' },
      { type: 'new', text: 'Upload slika i fajlova uz nalog (admin i worker)' },
      { type: 'new', text: 'Pauza i nastavak rada sa napomenom i slikama' },
      { type: 'new', text: 'Galerija slika po liftu' },
      { type: 'fix', text: 'Ispravljen PORT bug u backend konfiguraciji' },
    ],
  },
  {
    version: '1.0.0',
    date: '12.2025.',
    label: 'Inicijalni release',
    changes: [
      { type: 'new', text: 'Belkom EVA — sistem za praćenje radnih naloga servisa liftova' },
      { type: 'new', text: 'Kreiranje, dodela i praćenje naloga (servis, održavanje, popravka, defektaža, hitna)' },
      { type: 'new', text: 'Rolni sistem: admin, master, worker, direktor' },
      { type: 'new', text: 'Baza klijenata i liftova' },
      { type: 'new', text: 'Dashboard sa statistikama i grafikonima' },
      { type: 'new', text: 'Login stranica i autentifikacija' },
    ],
  },
];
